module.exports = __webpack_public_path__ + "img/jypx-8.3a7c1354.webp";